<template>
  <div>
    Display Doc Name Attributes Here...
  </div>
</template>

<script>
export default {
  name: 'DocNameAttributes',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
